export const templatePopin = {
	id: 'popin',
	styles: [],
	component: '<div data-gjs-type="popin_wrapper"></div>'
};
